import { FC } from 'react';
import styled from 'styled-components';
import { Address } from '../../../common/model/dto/address';
import { getAddressFullName } from '../../../common/utils/services/order-address-utils';

const OvOrderAddress: FC<{ address?: Address | null }> = ({ address }) => {
  if (!address) {
    return <StyledWrapper>-</StyledWrapper>;
  }

  return (
    <StyledWrapper>
      <StyledText>{getAddressFullName(address)}</StyledText>
      <StyledText>
        {address.address1 ?? '-'} {address.address2 ?? ''}
      </StyledText>
      <StyledText>
        {address.city}, {address.region_code}, {address.postal_code}
      </StyledText>
      <StyledText>
        {address.country} ({address.country_code})
      </StyledText>
      <StyledText>{address.phone}</StyledText>
    </StyledWrapper>
  );
};

export default OvOrderAddress;

const StyledWrapper = styled.address`
  font-style: normal;
  line-height: 1.5;
`;

const StyledText = styled.p`
  margin: 0;
  overflow-wrap: break-word;
`;
